<template>
  <div v-if="criterionFiles.length > 0" class="my-2 criterionFiles">
    <div v-if="showCaption" class="mb-2">Zugehörige Masterdokumente:</div>
    <ul class="criterionFilesList" style="list-style-type:square; list-style-position: inside;">
      <li v-for="criterionFile in criterionFiles" :key="criterionFile.cfi" class="criterionFile">
        {{ criterionFile.title }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    criterionId: {
      required: true,
      type: Number
    },
    showCaption: {
      default: false,
      required: false,
      type: Boolean
    }
  },
  components: {
  },
  computed: {
    ...mapGetters({
      criterionFilesByCriterionId: 'manual/criterionFilesByCriterionId'
    }),
    criterionFiles () {
      return this.criterionFilesByCriterionId(this.criterionId)
    }
  }
}
</script>
